import { BlogSection } from '@/types/blog';

export const warumMusik: BlogSection = {
  id: 'warum-musik',
  title: 'Warum Musik so viel mehr ist als Unterhaltung',
  content: `
    <p>
      Hinter jedem Ton steckt ein neuronales Feuerwerk. Musik stimuliert Areale in deinem Gehirn, die für Emotionen, Gedächtnis und Entscheidungsprozesse zuständig sind. Unser limbisches System, das Zentrum für Gefühl und Motivation, reagiert unmittelbar auf Melodien und Rhythmen – als würde es ihnen zuhören wollen, um uns zu führen statt zu manipulieren.
    </p>
  `
};
